import { z } from 'zod'

export const blockEventSchema = z.object({
  method: z.string(),
  section: z.string(),
  index: z.string(),
  data: z.union([z.array(z.unknown()), z.record(z.unknown())]),
})

export type BlockEvent = z.infer<typeof blockEventSchema>

export type BlockData = {
  blockNumber: number
  /** { extrinsic_index: events } */
  events: Map<number | undefined, readonly BlockEvent[]>
}

export type PolkadotAddress = `polkadot_${number}_${string}`

export type PolkadotAssetId = `polkadot_${number}_${bigint}`

export type PolkadotSource =
  | `polkadot_${number}_${number}-${number}`
  | `polkadot_${number}_${number}`
